export default __webpack_public_path__ + "static/media/IF_MyStrengths_StrengthDesc_01.a79aaf5e.jpg";